import { Component, OnInit } from '@angular/core';
import { IPedidoForm } from './pedido-material-layout.model';
import { HttpService } from '../../../services/common/http/common.http.service';
import Swal from 'sweetalert2';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-pedido-material-layout',
  templateUrl: './pedido-material-layout.component.html',
  styleUrls: ['./pedido-material-layout.component.scss'],
})
export class PedidoMaterialLayoutComponent implements OnInit {
  isViewing: boolean = false;
  resetList: boolean = false;
  loader: boolean = false;

  constructor(
    private httpService: HttpService,
    private router: Router,
    private activatedRoute: ActivatedRoute
  ) {}

  ngOnInit() {
    this.activateRoute();
  }

  form: IPedidoForm = {
    FornecedorId: 0,
    NmFornecedor: '',
    TxEmailFornecedor: '',
    TxTelefoneFornecedor: '',
    TxEnderecoFornecedor: '',
    VlPrecoFreteFornecedor: 0,
    VlTotal: 0,
    QtDiaPrevisto: 0,
    ObraDestinoId: 0,
    Materiais: [],
  };

  fornecedorOptions: any[] = [];
  obrasOptions: any[] = [];
  materiaisOptions: any[] = [];

  postForm(): void {
    this.loader = true;
    this.httpService.usePostFilter('CreatePedido', this.form).subscribe({
      next: (res: any) => {
        Swal.fire({
          title: 'Sucesso!',
          text: 'Pedido cadastrado com sucesso.',
          icon: 'success',
          confirmButtonText: 'Ok',
          confirmButtonColor: 'green',
        }).then(() => {
          this.router.navigate(['suprimentos']);
        });
      },
      error: (err: any) => {
        Swal.fire({
          title: 'Erro!',
          text: 'Erro ao cadastrar o pedido.',
          icon: 'error',
          confirmButtonText: 'Ok',
          confirmButtonColor: 'red',
        });
      },
      complete: () => {
        this.loader = false;
      },
    });
  }

  getFornecedores(): void {
    this.loader = true;
    this.httpService.useGet('FornecedorByFilter').subscribe({
      next: (res: any) => {
        this.fornecedorOptions = res.DataSet.map((fornecedor: any) => {
          return {
            name: fornecedor.NmFornecedor,
            value: fornecedor.IdFornecedor,
          };
        });
      },
      error: (err: any) => {},
      complete: () => {
        this.loader = false;
      },
    });
  }

  getObras(): void {
    this.loader = true;
    this.httpService.useGet('FrenteTrabalho').subscribe({
      next: (res: any) => {
        this.obrasOptions = res.FrenteTrabalhos.map((x: any) => {
          return {
            name: x.TxNome,
            value: x.IdFrenteTrabalho,
          };
        });
      },
      error: (err: any) => {},
      complete: () => {
        this.loader = false;
      },
    });
  }

  updateFornecedor(value: number): void {
    if (!value) return;
    this.loader = true;
    this.resetList = true;
    this.form.Materiais = [];
    this.httpService
      .useGet('FornecedorByFilter', { IdFornecedor: value })
      .subscribe({
        next: (res: any) => {
          const data = res.DataSet[0];
          this.form.FornecedorId = data.IdFornecedor;
          this.form.NmFornecedor = data.NmFornecedor;
          this.form.TxEmailFornecedor = data.TxEmailFornecedor;
          this.form.TxTelefoneFornecedor = data.TxTelefoneFornecedor;
          this.form.TxEnderecoFornecedor = data.TxEnderecoFornecedor;
          this.form.VlPrecoFreteFornecedor = data.VlPrecoFreteFornecedor;
          this.form.QtDiaPrevisto = data.QtDiaPrevisto;
          this.materiaisOptions = data.Materiais.map((material: any) => {
            return {
              name: material.NmMaterial,
              value: material.IdFornecedorMaterial,
              price: material.VlMaterial,
            };
          });
        },
        error: (err: any) => {},
        complete: () => {
          this.calcTotal();
          this.resetList = false;
          this.loader = false;
        },
      });
  }

  updateMateriais(materiais: any): void {
    if (!materiais) return;
    this.form.Materiais = materiais.map((material: any) => {
      return {
        NmMaterial: material.name,
        FornecedorMaterialId: material.value,
        VlMaterial: material.price,
        QtMaterial: 1,
      };
    });
    this.calcTotal();
  }

  updateObra(value: number): void {
    if (!value) return;
    this.form.ObraDestinoId = value;
  }

  calcTotal(): void {
    this.form.VlTotal = this.form.VlPrecoFreteFornecedor;
    if (this.form.Materiais.length) {
      const totalMateriais = this.form.Materiais.reduce(
        (acc, material) => acc + material.VlMaterial * material.QtMaterial,
        0
      );
      if (!totalMateriais) {
        return;
      }
      this.form.VlTotal = totalMateriais + this.form.VlPrecoFreteFornecedor;
    }
  }

  validarForm(): boolean {
    if (
      this.form.FornecedorId &&
      this.form.ObraDestinoId &&
      this.form.Materiais.length
    ) {
      return false;
    }
    return true;
  }

  activateRoute(): void {
    this.loader = true;
    this.getFornecedores();
    this.getObras();
    this.activatedRoute.queryParams.subscribe((params) => {
      const id = +params['numeroPedido'];
      if (!id) {
        this.loader = false;
        return;
      }
      this.isViewing = true;
      this.httpService.useGet('PedidoByFilter', { IdPedido: id }).subscribe({
        next: (res: any) => {
          const data = res.DataSet[0];
          this.form.FornecedorId = data.IdFornecedor;
          this.form.NmFornecedor = data.NmFornecedor;
          this.form.TxEmailFornecedor = data.TxEmailFornecedor;
          this.form.TxTelefoneFornecedor = data.TxTelefoneFornecedor;
          this.form.TxEnderecoFornecedor = data.TxEnderecoFornecedor;
          this.form.VlPrecoFreteFornecedor = data.VlPrecoFreteFornecedor;
          this.form.VlTotal = data.VlTotal;
          this.form.QtDiaPrevisto = data.QtDiaPrevisto;
          this.form.ObraDestinoId = data.IdFrenteTrabalho;
          this.form.Materiais.push({
            NmMaterial: data.NmMaterial,
            FornecedorMaterialId: data.IdFornecedor,
            VlMaterial: data.VlTotal,
            QtMaterial: data.QtPedido,
          });
          this.updateFornecedor(data.IdFornecedor);
        },
        error: (err: any) => {},
        complete: () => {
          this.loader = false;
        },
      });
    });
  }
}
